import { createContext, useContext } from "react";
import { usePMToasts } from "@/ds/vendor";

export type Toast = { variant?: "success" | "error" | "info" | "warning"; title?: string; message?: string };
export const ToastCtx = createContext<(t: Toast) => void>(() => {});
export const useToast = () => useContext(ToastCtx);
export const useToastQueue = () => usePMToasts({ duration: 4500 });
